'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = require('./components/Login.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Login).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/login/lib/components/login/index.js
// module id = 1430
// module chunks = 1